import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'
import type { MedflexServiceClass } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/types/medflex'

export type PriceCategoryNavItem = {
  name: string
}

/**
 * Пункты сайдбара категорий: имена из `service_categories`,
 * иначе — из текущего списка классов прайса.
 */
export default function getCategoryNavItems(
  categories: string[] | Record<string, string> | null | undefined,
  serviceClasses: MedflexServiceClass[],
): PriceCategoryNavItem[] {
  const categoryNames = unwrapList(categories)
  const names = categoryNames.length
    ? categoryNames
    : serviceClasses.map(item => item.name)

  return names.map(name => ({ name }))
}
